import React, { useState, useEffect, useRef } from 'react';import JupiterSwap from '../components/JupiterSwap';
import styles from '../styles/SwapPage.module.css';
import Kaiya from '../components/kaiya';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';

const SwapPage: React.FC = () => {
      const copyToClipboard = () => {
        navigator.clipboard.writeText(walletAddress);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      };
    
       const [copied, setCopied] = useState(false);
       const walletAddress = "FqnqT1GKi8S4Gyk5wnSKvJjXW48HqGtKJt9WS4o2pump";
       return (
        <>
         <Navbar />
        <div className={styles.swapPage}>
          <div className={styles.heroSection}>
            <h1>Get $BAKSO!</h1>
            <p>Swap from SOL to $BAKSO!</p>
          </div>
      
          <div className={styles.swapContent}>
            <div className={styles.infoSection}>
              <h2>New to Solana?</h2>
              <div className={styles.tigerDivider}></div>
              <ol>
                <li>
                  <strong>🦁 Set Up a Phantom Wallet</strong>
                  <p>
                    Download the <a href="https://phantom.app/" target="_blank" rel="noopener noreferrer">Phantom Wallet</a> as a mobile app or browser extension. Create your Solana wallet and securely save your recovery phrase (never share it!).
                  </p>
                </li>
                <li>
                  <strong>💸 Add SOL to Your Wallet</strong>
                  <p>
                    Buy SOL directly in Phantom using a card, or purchase SOL on an exchange like <a href='https://coinbase.com/' target="_blank" rel="noopener noreferrer">Coinbase</a> or <a href='https://www.kraken.com/' target="_blank" rel="noopener noreferrer">Kraken</a> and transfer it to your Phantom wallet.
                  </p>
                </li>
                <li>
                  <strong>🐯 Swap SOL for $BAKSO</strong>
                  <p>Use one of these simple methods to get $BAKSO:</p>
                  <ul>
                    <li>
                      <strong>In Phantom:</strong>
                      <ol>
                        <li>Open the "Swap" feature.</li>
                        <li>Select SOL as "You Pay."</li>
                        <li>
                          Paste the $BAKSO contract address: <code>FqnqT1GKi8S4Gyk5wnSKvJjXW48HqGtKJt9WS4o2pump</code>
                            <button
                              className={styles.copyButton}
                              onClick={copyToClipboard}
                              title="Copy to clipboard"
                            >
                              {copied ? "Copied! ✓" : "Copy"}
                            </button>
                          and choose $BAKSO as "You Receive."
                        </li>
                        <li>Enter the SOL amount, click "Swap Now," and confirm.</li>
                      </ol>
                    </li>
                    <li>
                      <strong>Via Jupiter:</strong>
                      <ol>
                        <li>Open Jupiter Swap in Phantom’s browser or go to their <a href='https://jup.ag/swap/SOL-Bakso' target="_blank" rel="noopener noreferrer">website</a>.</li>
                        <li>Ensure the pair is SOL → $BAKSO.</li>
                        <li>Enter the SOL amount, click "Swap," and confirm.</li>
                      </ol>
                    </li>
                  </ul>
                </li>
              </ol>
            </div>
      
            <div className={styles.swapWidget}>
              <JupiterSwap />
            </div>
           
          </div>
          
        </div>
        
        <Footer />
        <Kaiya />
        </>
      );
};

export default SwapPage;